import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx } from 'react/jsx-runtime';

var Svg18NotionG = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      fill: props.iconColor ? props.iconColor : "#010505",
      fillRule: "evenodd",
      d: "M9 2.045c2.788 0 5.043 2.294 5.154 5.148l.005.22-.001 2.579 1.05.887c.212.18.357.421.417.687l.022.134.008.138v.632c0 .654-.502 1.189-1.14 1.253l-.13.007h-2.592c-.228 1.535-1.348 2.625-2.793 2.625s-2.565-1.09-2.793-2.625H3.615a1.266 1.266 0 0 1-1.263-1.13l-.007-.13v-.632c0-.323.126-.632.346-.864l.1-.095 1.05-.887V7.413c0-2.805 2.072-5.122 4.729-5.35l.217-.013zm1.446 11.752H7.553l.004.015c.178.661.62 1.103 1.178 1.209l.13.018.135.006c.634 0 1.163-.41 1.397-1.084zM9 3.355c-2.056 0-3.741 1.7-3.845 3.85l-.005.208V10.6l-1.496 1.264v.556h10.691v-.556L12.85 10.6V7.413c0-2.246-1.728-4.058-3.85-4.058"
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg18NotionG$1 = Svg18NotionG;

export { Svg18NotionG$1 as default };
